import { ADVISOR_KEY, appointmentUrls, VERSION } from "../../constants/ApiUrls";
import {
  getData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getAppointment = async () => {
  return await getData(ADVISOR_KEY + VERSION + appointmentUrls.APPOINTMENT);
};
export const getAdvisorAppointments = async (id, search = "") => {
  return await getData(
    ADVISOR_KEY +
      VERSION +
      `${id}/${appointmentUrls.APPOINTMENTS}?searchString=${search}`
  );
};
export const postAppointment = async (payload, id) => {
  return await postData(
    ADVISOR_KEY + VERSION + `${id}/${appointmentUrls.APPOINTMENT}`,
    payload
  );
};
export const updateAppointment = (data, id) => {
  return updateData(
    ADVISOR_KEY + VERSION + `${id}/${appointmentUrls.APPOINTMENTS}`,
    data
  );
};

export const postAdvisorAppointment = async (payload, id) => {
  return await postData(
    ADVISOR_KEY + VERSION + `${id}/${appointmentUrls.APPOINTMENTS}`,
    payload
  );
};
